import { render, staticRenderFns } from "./sectionTours.vue?vue&type=template&id=3096b3b0&"
import script from "./sectionTours.vue?vue&type=script&lang=js&"
export * from "./sectionTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports